import React from 'react'
import TricksDetails from '../../components/MyTricksDetails'

const MyTricksSettings = () => {
  return (
    <><TricksDetails parent='my-tricks' /></>
  )
}

export default MyTricksSettings